import { render } from "./h_drink_awa.vue?vue&type=template&id=c4bcb83a&scoped=true"
import script from "./h_drink_awa.vue?vue&type=script&lang=js"
export * from "./h_drink_awa.vue?vue&type=script&lang=js"

import "./h_drink_awa.vue?vue&type=style&index=0&id=c4bcb83a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4bcb83a"]])

export default __exports__